import { render, staticRenderFns } from "./HornorBuyGoodsOrder.vue?vue&type=template&id=5270bc26&scoped=true&"
import script from "./HornorBuyGoodsOrder.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGoodsOrder.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGoodsOrder.vue?vue&type=style&index=0&id=5270bc26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270bc26",
  null
  
)

export default component.exports